import { ToastProvider, theme } from "@chakra-ui/react"
import { AppTheme, WSysPath } from "@coimbra-its/websys-ux-core"
import * as ReactDOM from "react-dom/client"
import { App } from "./App"
import { APPICONS } from "./Icons"
import * as serviceWorker from "./serviceWorker"


const preferencesCompanyDefault = `{"darkMode":false,"baseColor":"#df8c24","selectionColor":"#ffffcc","modeMain":"POPUPS","modeAttach":"COLUMNS","modePopup":"POPUPS","layoutAlign":"CENTER","colors":{"theme1":{"value":"#df8c24"},"theme2":{"value":"#df8c24"},"menu":{"value":"#de8a21","derived":{"method":"SHADE","color1":"theme1","p1":50}},"tableHead":{"value":"#f8e8d3","derived":{"method":"SHADE","color1":"theme1","p1":10}}}}`;
const chakraTheme = {
	initialColorMode: 'dark',
	useSystemColorMode: false,
	colors: {
		wsysLine: 'transparent',
	},
	fonts: {
		body: `montserrat`,
	},
	styles: {
		global: {
			'body': {
				backgroundImage: 'url(images/bg.png)',
				backgroundPosition: 'center',
				backgroundRepeat: 'no-repeat',
				backgroundSize: 'cover',
				backgroundAttachment: 'fixed',
			}
		}
	},
	components: {
		Button: {
			variants: {
				wsysHeadIconButton: (props: any) => ({
					...theme.components.Button.variants!.link(props),
					color: '#fff'
				})
			}
		}


	}
};



const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);



root.render(
	<WSysPath>
		<AppTheme icons={APPICONS} preferencesCompanyDefault={preferencesCompanyDefault} appCustomChakraTheme={chakraTheme} >
			<App />
			<ToastProvider />

		</AppTheme>
	</WSysPath>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister()

